import Hotjar from '@hotjar/browser';
import { isProduction } from '../utils/environment';

export const initHotjar = () => {
  if (isProduction) {
    Hotjar.init(4996766, 6);
  }
};

export interface UserInfo {
  [key: string]: string | number | boolean;
}

export const identifyUser = (userId: number, userInfo: UserInfo) => {
  if (isProduction) {
    Hotjar.identify(userId.toString(), userInfo);
  }
};
